import { blobDatabase } from 'modules-core/cache'
import { createDefaultEffectParams } from '../constants'
import { AudioEffect } from '../types'
import { createAudioEffect } from './createEffect'
import config from 'modules-core/config'
import log from 'modules-core/log'

const logger = log.getLogger('convolverEffect')

export const createConvolverEffect = async (
	params: AudioEffect.ConvolverEffectParams = {}
) => {
	params = Object.assign(createDefaultEffectParams('convolver'), params)

	try {
		const blob = await blobDatabase.getBlob(params.url)
		const arrayBuffer = await blob.arrayBuffer()
		const audioBuffer = await config.audioContext.decodeAudioData(arrayBuffer)

		const node = config.audioContext.createConvolver()
		node.buffer = audioBuffer

		const effect = {
			...createAudioEffect(node),
			params,
			setParam: {},
		} as AudioEffect.ConvolverEffect

		return effect
	} catch (error) {
		// Log the failed convolver load but don't throw - this allows the audio system to continue
		logger.warn(
			`Failed to load convolver "${params.name}" from URL "${params.url}":`,
			error
		)

		if (
			typeof window !== 'undefined' &&
			window.Sentry &&
			window.Sentry.syrinscape
		) {
			const Sentry = window.Sentry
			Sentry.withScope((scope: any) => {
				scope.setTag('convolver.name', params.name)
				scope.setTag('convolver.url', params.url)
				Sentry.captureMessage('Failed to load convolver')
				Sentry.captureException(error)
			})
		}

		// Create a dummy convolver effect that doesn't process audio
		// This ensures the effect chain remains intact even when convolvers fail to load
		const node = config.audioContext.createConvolver()
		// Leave node.buffer as null - this creates a passthrough convolver

		const effect = {
			...createAudioEffect(node),
			params,
			setParam: {},
		} as AudioEffect.ConvolverEffect

		return effect
	}
}
